export const EZDRP_System_RozmiarStrony = 'EZDRP.System.RozmiarStrony';
export const EZDRP_System_PotwierdzeniePrawidlowejOperacji =
  'EZDRP.System.PotwierdzeniePrawidlowejOperacji';
